import "core-js/modules/es6.regexp.split";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import moment from 'moment';
import pick from 'lodash.pick';
import IwsUpload from '@comp/upload/IwsUpload';
import { getAction, httpAction } from '@api/manage';
import { queryUserTreeList as _queryUserTreeList } from '@/api/api';
export default {
  name: 'CarInspectionModal',
  mixins: [ModalFormMixin],
  components: {
    IwsUpload: IwsUpload
  },
  data: function data() {
    return {
      loginUser: '',
      carList: [],
      carDisableStatus: false,
      userTree: [],
      title: '车辆年检记录表单',
      tableName: 'ea_asset_car_inspection',
      form_fields: ['carId', 'userId', 'vehicleAdministrativeOffice', 'inspectionContent', 'cost', 'inspectionStatus', 'status', 'unQualified', 'remark', 'tenantId'],
      form_fields_time: ['inspectionDate', 'nextDate'],
      validatorRules: {
        carId: {
          rules: [{
            required: true,
            message: '请选择车辆!'
          }]
        },
        inspectionStatus: {
          rules: [{
            required: true,
            message: '请选择合格情况!'
          }]
        },
        status: {
          rules: [{
            required: true,
            message: '请选择年检状态!'
          }]
        },
        userId: {
          rules: [{
            required: true,
            message: '请选择送检人员!'
          }]
        },
        vehicleAdministrativeOffice: {
          rules: [{
            required: true,
            message: '请输入车管所名称!'
          }]
        },
        inspectionDate: {
          rules: [{
            required: true,
            message: '请选择送检时间!'
          }]
        },
        nextDate: {
          rules: [{
            required: true,
            message: '请选择下次送检时间!'
          }]
        },
        cost: {
          rules: [{
            required: true,
            message: '请输入费用!'
          }]
        },
        inspectionContent: {
          rules: [{
            required: true,
            message: '请输入年检内容!'
          }]
        }
      },
      url: {
        carList: '/ea/asset/car/queryCarCards'
      }
    };
  },
  props: {
    pagePath: String,
    carDetails: Boolean,
    carId: {
      type: Number,
      default: null
    },
    permissionObj: {
      type: Object,
      default: function _default() {
        edit: '';
      }
    }
  },
  created: function created() {
    this.queryUserTreeList();
    this.queryCarList();
    this.loginUser = this.$store.getters.userInfo.id;
  },
  methods: {
    moment: moment,
    add: function add() {
      this.carDisableStatus = false;
      this.edit({});
    },
    edit: function edit(record) {
      var _this = this;

      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;

      if (this.carDetails) {
        this.carDisableStatus = true;
        this.model.carId = parseInt(this.carId);
      }

      if (!this.model.userId) {
        this.model.userId = this.loginUser;
        this.model.inspectionDate = moment(new Date(), 'YYYY-MM-DD HH:mm:ss');
      }

      this.$nextTick(function () {
        var that = _this; //debugger

        that.form.setFieldsValue(pick(that.model, that.form_fields)); //时间格式化

        var timeVal = {};
        that.form_fields_time.forEach(function (item, index) {
          timeVal[item] = that.model[item] ? moment(that.model[item], 'YYYY-MM-DD HH:mm:ss') : null;
        });
        that.form.setFieldsValue(timeVal);

        _this.$refs.iwupload.loadUploadFiles();
      });
    },
    queryCarList: function queryCarList() {
      var that = this;
      that.carList = [];
      getAction(that.url.carList).then(function (res) {
        if (res.success) {
          that.carList = res.result;
        }
      });
    },
    queryUserTreeList: function queryUserTreeList() {
      var _this2 = this;

      var that = this;
      that.userTree = []; // 用户

      _queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }

          _this2.loading = false;
        }
      });
    },
    handleOk: function handleOk() {
      var _this3 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var formData = Object.assign(that.model, values); //时间格式化

          formData.inspectionDate = formData.inspectionDate ? formData.inspectionDate.format('YYYY-MM-DD HH:mm:ss') : null;
          formData.nextDate = formData.nextDate ? formData.nextDate.format('YYYY-MM-DD HH:mm:ss') : null;
          formData = _this3.$refs.iwupload.getUploadListToFromData(formData); //debugger
          //console.log(formData)

          var httpurl = '',
              method = '';
          var headers = {
            tableName: _this3.permissionObj.edit.split(':')[1]
          };

          if (!_this3.model.id) {
            httpurl = _this3.url.add ? _this3.url.add : _this3.pagePath;
            method = 'post';
          } else {
            httpurl = _this3.url.edit ? _this3.url.edit : _this3.pagePath;
            method = 'put';

            if (_this3.permissionObj.edit) {
              headers.id = _this3.model.id; // let largePermission = getLargePermission({ value: that.permissionObj.edit })
              // getBindingValue(headers, largePermission)
            }
          }

          httpAction(httpurl, formData, method, headers).then(function (res) {
            if (res.success) {
              _this3.$refs.iwupload.resetUploadFiles();

              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    filterOption: function filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
  }
};